import { BaseCheckbox } from '@service-victoria/component-library/components/Checkbox/BaseCheckbox';
import colors from '@service-victoria/component-library/utils/colors';
import { useField } from 'formik';
import React from 'react';

import * as Styled from './styled';

type ComponentProps = {
  fieldName: string;
};

const ConsentCheckbox: React.FC<React.PropsWithChildren<ComponentProps>> = ({
  fieldName,
  children
}) => {
  const [{ value: isChecked }, { error, touched }, { setValue, setTouched }] =
    useField<boolean>(fieldName);

  return (
    <>
      <Styled.ConsentWrapper>
        <BaseCheckbox
          name={fieldName}
          checked={isChecked}
          error={touched ? error : undefined}
          labelProps={{ children, style: { textDecoration: 'none', color: colors.blueGrey } }}
          errorLabelProps={{ style: { display: 'block', marginBottom: 0 } }}
          onChange={() => {
            setTouched(true);
            setValue(!isChecked);
          }}
        />
      </Styled.ConsentWrapper>
    </>
  );
};

export default ConsentCheckbox;
